import React, { FC } from 'react';

import { Message, LocalLoading } from '../../../shared/components';
import BookWithUnfinishedTrajectories from './BookWithUnfinishedTrajectories';
import { useStudentFeedback } from '../../../feedback/hooks';
import { useGetStudentBookBagQuery } from 'src/modules/shared/slices/student/api/students';

type UnfinishedTrajectoriesProps = {
  style?: React.CSSProperties;
};

const UnfinishedTrajectories: FC<UnfinishedTrajectoriesProps> = ({
  style,
}: UnfinishedTrajectoriesProps) => {
  const { feedback: studentFeedback } = useStudentFeedback();
  const {
    data: studentBookBag,
    isFetching: studentBookBagIsFetching,
    isError: studentBookBagIsError,
    error: studentBookBagError,
    isSuccess: studentBookBagIsSuccess,
  } = useGetStudentBookBagQuery();

  return (
    <div style={style}>
      {studentBookBagIsFetching && <LocalLoading />}
      {studentBookBagIsError && <Message type="error">{studentBookBagError}</Message>}
      {studentBookBagIsSuccess &&
        studentBookBag.map((book, index) => (
          <BookWithUnfinishedTrajectories
            key={index}
            book={book}
            lastViewedTrajectory={book.lastViewedTrajectory}
            bookmark={book.bookmark}
            studentFeedback={studentFeedback
              ?.find((item) => item.bookId === book.id)
              ?.trajectoryFeedbacks?.flatMap((item) => item.feedbacks)}
          />
        ))}
    </div>
  );
};

export default UnfinishedTrajectories;
